import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { ReservationsDetailsComponent } from './reservations-details/reservations-details.component';
import { QualificationDetailsComponent } from './qualification-details/qualification-details.component';
import { AdditionalDetailsComponent } from './additional-details/additional-details.component';
import { PhotoSignatureDetailsComponent } from './photo-signature-details/photo-signature-details.component';
import { AdmissionDetailsComponent } from './admission-details/admission-details.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { StudentRegistrationTabComponent } from './student-registration-tab/student-registration-tab.component';
import { StudentSettingComponent } from './student-setting/student-setting.component';
import { StudentFormComponent } from './student-form/student-form.component';
import { AdminSettingComponent } from './admin-setting/admin-setting.component';
import { StudentRegisterComponent } from './student-register/student-register.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { FeesComponent } from './fees/fees.component';
import { FeeProcessComponent } from './fee-process/fee-process.component';
import { ExamFormComponent } from './exam-form/exam-form.component';
import { ExamFeesComponent } from './exam-fees/exam-fees.component';
import { ExamFeeProcessComponent } from './exam-fee-process/exam-fee-process.component';
import { ReportsComponent } from './reports/reports.component';
import { AdmitCardComponent } from './admit-card/admit-card.component';
import { MarklistComponent } from './marklist/marklist.component';
import { OpenCollegeAddmissionComponent } from './open-college-addmission/open-college-addmission.component';
import { DownloadDetailsComponent } from './download-details/download-details.component';
import { SubjectSelectionComponent } from './subject-selection/subject-selection.component';
import { ComplaintFormComponent } from './complaint-form/complaint-form.component';
import { TCLCMCComponent } from './tc-lc-mc/tc-lc-mc.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { TclcFeesComponent } from './tclc-fees/tclc-fees.component';
import { TclcFeesProcessComponent } from './tclc-fees-process/tclc-fees-process.component';
import { GrievanceCommentFormComponent } from './grievance-comment-form/grievance-comment-form.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { CertificateComponent } from './certificate/certificate.component';
import { TranscriptComponent } from './transcript/transcript.component';
import { EasebuzzPayComponent } from './easebuzz-pay/easebuzz-pay.component';
import { RazorpayPayComponent } from './razorpay-pay/razorpay-pay.component';
import { ProvisionalComponent } from './provisional/provisional.component';
import { CertificateLoginComponent } from './certificate-login/certificate-login.component';
import { PracticalTimeTableComponent } from './practical-time-table/practical-time-table.component';
import { AuthGuard } from './auth.guard';


const routes: Routes = [
  {
    path: 'student-registration',
    component: StudentRegisterComponent
  },
  {
    path: 'student-login',
    component: StudentLoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgetPasswordComponent
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      ////New Comp
      {
        path: 'personal-details',
        component: PersonalDetailsComponent
      },
      {
        path: 'contact-details',
        component: ContactDetailsComponent
      },
      {
        path: 'reservations-details',
        component: ReservationsDetailsComponent
      },
      {
        path: 'reports',
        component:  ReportsComponent
      },
      {
        path: 'Admit-Card',
        component:  AdmitCardComponent
      },
      {
        path: 'Marklist',
        component:  MarklistComponent
      },
      {
        path: 'qualification-details',
        component: QualificationDetailsComponent
      },
      {
        path: 'additional-details',
        component: AdditionalDetailsComponent
      },
      {
        path: 'photo-signature-details',
        component: PhotoSignatureDetailsComponent
      },
      {
        path: 'admission-details',
        component: AdmissionDetailsComponent
      },
      {
        path: 'document-detailss',
        component: DocumentDetailsComponent
      },
      {
        path: 'student-registration-tab',
        component: StudentRegistrationTabComponent
      },
      {
        path: 'student-setting',
        component: StudentSettingComponent
      },
      {
        path: 'student-form',
        component: StudentFormComponent
      },
      {
        path: 'admin-setting',
        component: AdminSettingComponent
      },
      {
        path: 'certificate-login',
        component: CertificateLoginComponent
      },
      {
        path: 'Fees',
        component: FeesComponent
      },
      { path: 'Fees-Process',
      component: FeeProcessComponent
      },
      {
        path: 'Exam-Form',
        component: ExamFormComponent
      },
      {
        path: 'Exam-Fees',
        component: ExamFeesComponent
      },
      { path: 'Exam-Fees-Process',
      component: ExamFeeProcessComponent
      },
      { path: 'OpenAddmission',
      component: OpenCollegeAddmissionComponent
      },
      {
        path: 'download-details',
        component: DownloadDetailsComponent
      },
      {
        path: 'Subject-Selection',
        component: SubjectSelectionComponent
      },
      {
        path: 'complaint-form',
        component: ComplaintFormComponent
      },
      {
        path: 'TC-LC-MC',
        component: TCLCMCComponent
      },
      {
        path: 'TCLCFees',
        component: TclcFeesComponent
      },
      {
        path: 'TCFeesProcess',
        component: TclcFeesProcessComponent
      },
      {
        path: 'Complaint',
        component: ComplaintComponent
      },
      {
        path: 'grievance-comment-form',
        component: GrievanceCommentFormComponent
      },
      {
        path: 'Certificate/:data',
        component: CertificateComponent
      },
      {
        path: 'Transcript',
        component: TranscriptComponent
      },
      {
        path: 'easebuzz',
        component: EasebuzzPayComponent
      },
      {
        path: 'razorpay',
        component: RazorpayPayComponent
      },
      {
        path: 'provisional',
        component: ProvisionalComponent
      },
      {
        path: 'practical-time-table',
        component: PracticalTimeTableComponent
      },
    ]
  },
  { 
    path: '**',
    redirectTo: 'student-login'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'student-login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
